import * as React from "react";
import {RouteComponentProps} from "react-router-dom";
import {COLOR} from "utils/variables";

interface IProps {
    children: React.ReactNode;
    headerTitle?: string;
    headerBackgroundColor?: string;
    headerTextColor?: string;
    bodyBackgroundColor?: string;
    bodyTextColor?: string;
    addtionalField?: React.ReactNode;
}

export const BasicCard = (props: IProps & RouteComponentProps) => {
    const containerStyle = {
        boxShadow: `0px 3px 6px ${COLOR.SHADOW}`,
        borderRadius: 5,
        overflow: "hidden",
        margin: 5,
    };
    const headerStyle = {
        backgroundColor: props.headerBackgroundColor ? props.headerBackgroundColor : COLOR.PRIMARY,
        color: props.headerTextColor ? props.headerTextColor : COLOR.WHITE,
        fontSize: "18px",
        fontWeight: 500,
        padding: "10px 7px",
        display: "flex",
        justifyContent: "space-between",
    };
    const bodyStyle = {
        backgroundColor: props.bodyBackgroundColor ? props.bodyBackgroundColor : COLOR.WHITE,
        color: props.bodyTextColor ? props.bodyTextColor : COLOR.BLACK,
        padding: 7,
        fontSize: "15px",
    };
    return (
        <div style={containerStyle}>
            {
                props.headerTitle &&
                <div style={headerStyle} >
                    <div>{props.headerTitle}</div>
                    {props.addtionalField && <div style={{minWidth: 95}}>{props.addtionalField}</div>}
                </div>
            }
            <div style={bodyStyle}>
                {props.children}
            </div>
        </div>
    );
};

export default BasicCard;
